class NSSCarousel extends HTMLElement {

    constructor() {
        super();

        this.debug = false;

        this.swiper;

        this.videoSlideEls = this.querySelectorAll(`[nss-video-playing]`);
    }

    connectedCallback() {
        if (this.debug) console.log("[NSS][Carousel] Connected.");

        this.initCarousel();

        this.addEventListener(`click`, (e) => {
            if (e.target.hasAttribute(`nss-video-playing`)) {
                if (e.target.getAttribute(`nss-video-playing`) === "false") {
                    this.stopAllVideos();
                    e.target.setAttribute(`nss-video-playing`, true);
                    const videoEl = e.target.querySelector(`video`);
                    videoEl.volume = 0.2;
                    videoEl.muted = false;
                    videoEl.play();
                } else {
                    this.stopAllVideos();
                }
            }
        });
        const editorEvents = [
            `shopify:inspector:activate`,
            `shopify:inspector:deactivate`,
            `shopify:section:load`,
            `shopify:section:unload`,
            `shopify:section:select`,
            `shopify:section:deselect`,
            `shopify:section:reorder`,
            `shopify:block:select`,
            `shopify:block:deselect`,
        ]
        editorEvents.forEach((event) => {
            this.addEventListener(event, this.handleEditorEvent.bind(this));
        });
    }

    stopAllVideos() {
        this.videoSlideEls.forEach((videoSlideEl) => {
            const videoEl = videoSlideEl.querySelector(`video`);
            videoEl.pause();
            videoEl.muted = true;
            videoSlideEl.setAttribute(`nss-video-playing`, false);
        });
    }

    initCarousel() {
        const carouselEl = this.querySelector(`.swiper`);
        const settings = JSON.parse(this.querySelector(`#swiper-settings`).textContent);
        const carouselElSlides = this.querySelectorAll(`.swiper-slide`);
        if (this.debug) console.log("[NSS][Carousel] settings:", settings);

        const seeMoreToggle = this.querySelector(`.js-nss-carousel-more-links`);
        if (seeMoreToggle != null) {
            if (carouselElSlides.length > 4) {
                seeMoreToggle.classList.add("is-show-show-more");
                seeMoreToggle.querySelector(".nss-link").textContent = "see more (" + (carouselElSlides.length - 4) + ")";
                seeMoreToggle.addEventListener("click", e => {
                    e.preventDefault();
                    this.classList.add("is-show-all");
                });
            }
        }
const self =this;
        const presets = {
            a11y: {
                enabled: true,
            },
            navigation: {
                prevEl: '.nss-carousel-button-prev',
                nextEl: '.nss-carousel-button-next',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    const el = carouselElSlides[index];
                    const img = el.getAttribute("data-img");
                    let html = '';
                    if (img != '') {
                        html = '<img alt="" src="' + img + '" />' +
                            '<svg width="100%" height="100%" viewBox="0 0 100 100"><circle stroke="rgba(0, 0, 0, 0.12)" fill="transparent" cx="50" cy="50" r="49" stroke-width="1.5"></circle><circle class="js-progress" stroke="#000" cx="50" cy="50" r="49" fill="transparent" stroke-width="1.5" pathLength="100" stroke-dasharray="100 100"></circle></svg>';
                    }
                    return '<div class="' + className + '" data-index="' + index + '">' + html + '</div>';
                },
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true
            },
            grabCursor: true,
            on: {
                autoplayTimeLeft(swiper, time, progress) {
                    const value = (1 - progress) * 100;

                    self.querySelectorAll('[aria-current="true"] .js-progress').forEach(el => {
                        el.setAttribute('stroke-dasharray', `${value} 100`);
                    });
                },
                slideChange() {
                    self.querySelectorAll('.js-progress').forEach(el => {
                        el.setAttribute('stroke-dasharray', '100 100');
                    });
                }

            },

        }

        const allSettings = Object.assign(presets, settings);
        if (this.debug) console.log("[NSS][Carousel] allSettings:", allSettings);
        this.querySelectorAll(`.swiper-slide`).forEach((slide, index) => {

            slide.addEventListener("mouseenter", e => {
                slide.classList.toggle('is-hover');
                setTimeout(() => {
                    this.swiper?.update();
                }, 500)
            })
            slide.addEventListener("mouseleave", e => {
                slide.classList.toggle('is-hover');
                setTimeout(() => {
                    this.swiper?.update();
                }, 500)
            })
            slide.addEventListener("click", e => {
                slide.classList.toggle('is-open');
                setTimeout(() => {
                    this.swiper?.update();
                }, 500)
            })
        })
        this.swiper = new Swiper(carouselEl, allSettings);


    }

    handleEditorEvent(e) {
        if (this.debug) console.log("[NSS][Carousel] Handle editor event, e:", e);

        switch (e.type) {

            case `shopify:block:select`:
                const blockEl = e.detail.blockId ? this.querySelector(`[data-block-id="${e.detail.blockId}"]`) : null;
                const slideEl = blockEl?.closest(`.swiper-slide`);
                if (this.debug) console.log("[NSS][Carousel] slideEl:", slideEl);
                if (slideEl) {
                    // const index = slideEl.getAttribute(`data-swiper-slide-index`);
                    const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
                    const index = slideEls.indexOf(slideEl);
                    if (this.debug) console.log("[NSS][Carousel] Sliding to index:", index);
                    this.swiper.slideTo(index);
                }
                break;

        }
    }
}

let elementName = `nss-carousel`;
if (typeof customElements.get(elementName) === `undefined`) {
    customElements.define(elementName, NSSCarousel);
}